import React from 'react'

import { OrderSyncErrorCell } from './OrderSyncErrorCell'

import { MyRowProps } from '../../types/tableTypes'
import { YandexMarketOrderModel } from '../../server/mpsklad_core/Models/Orders/YandexMarketOrderModel'

export const YandexMarketOrderSyncErrorCell =
  ({row}: MyRowProps<YandexMarketOrderModel>) =>
    <OrderSyncErrorCell type={'YandexMarket'} row={row}/>